module.exports = __webpack_public_path__ + "img/flowData163@3x.4a3f5778.png";